import { Language } from "../context/LanguageContext";

export interface FidrildiStoneTranslations {
  title: {
    firstLine: string;
    secondLine: string;
  };
  introduction: string;
  sections: {
    description: string;
  }[];
}

export const getFidrildiStoneTranslations = (
  language: Language
): FidrildiStoneTranslations => {
  switch (language) {
    default:
      return {
        title: {
          firstLine: "Fidrildi and",
          secondLine: "the Philosopher's Stone",
        },
        introduction: `Ancient cultures, such as the Vikings, fully incorporated elements of their mythology into their thinking and actions, which certainly made their lives more colorful and richer than lives that only believe in the existence of their own coffee machine, the stock market, and the leaflet that comes with their headache pills.
Niveau élevé creates so-called "Important Objects" from precious stones, drawing on ancient cultures in their choice of motifs, especially the ancient Nordic culture with its witches and elves, goblins and dwarves, Valkyries, giants, trolls, and unicorns.

The Philosopher's Stone:
The exact age of the story of the Philosopher's Stone is unknown. In any case, it symbolizes alchemy, that is, discovery and progress. It is the declared goal of all alchemists, both in material and spiritual research. Hermes Trismegistus, the founder of alchemy, supposedly engraved the formula for the Philosopher's Stone on an emerald tablet. Hermes Trismegistus is a fusion of the Greek god Hermes and the Egyptian god Thoth.
The Philosopher's Stone was the stone that was believed to possess the magical power of transformation. It was said to be able to transform base metals into gold, but it could also transform a person's character and consciousness.

The ancient Egyptian Greek alchemist Zosimos of Panopolis, who lived in the late 3rd to early 4th century, described the philosopher's stone as follows: "This stone that is not a stone, this precious thing that is without value, this multifaceted thing that has no form, this unknown thing that everyone knows."
The search for the Philosopher's Stone reached its peak in the Middle Ages, but continued into the Renaissance, presumably due to the financial constraints of many princes. Elector Christian II of Saxony even had the alchemist Seton tortured in order to obtain the secret of the Philosopher's Stone.`,
        sections: [
          {
            description:
              "The gemstone group \"Fidrildi and the Philosopher's Stone\" consists of an aquamarine weighing 15,250 carats. This makes it heavier than the Dom Pedro in the Museum of National History in Washington, which weighs 10,363 carats. The Dom Pedro was till recently considered the largest known cut aquamarine in the world. Thus, the Philosopher's Stone of Niveau élevé is the largest known cut aquamarine in the world as of today.\nThe fairy Fidrildi is made of morganite. The two are set in an amethyst cluster.",
          },
        ],
      };
  }
}; 